import { objectKeys } from 'src/utils/objectKeys';
import { objectEntries } from 'src/utils/objectEntries';
import { MultiSelectionItem } from 'src/components/common/MultiSelectionList';
import { CategoriesExport } from 'src/components/ProductAlerts/types/AlertResults/CategoriesExport';

export type ColumnId = keyof CategoriesExport.ListItem;

export const exportHeaders = {
  ownerName: 'Owner Name',
  categoryPath: 'Category Path',
} as const satisfies Record<ColumnId, string>;

export const columnOptions: MultiSelectionItem[] = objectEntries(exportHeaders).map(([value, label]) => ({
  value,
  label,
}));

export const defaultColumnIds: ColumnId[] = objectKeys(exportHeaders);
